import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getStoredDeviceFingerprint } from '../utils/deviceFingerprint';
import api from '../services/api';

const VisitorTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const trackVisit = async () => {
      try {
        const deviceFingerprint = getStoredDeviceFingerprint();
        const pageVisited = location.pathname + location.search;
        
        // Track visit asynchronously - don't block page load
        api.post('/api/visitors/track', {
          deviceFingerprint: deviceFingerprint,
          pageVisited: pageVisited
        }).catch(error => {
          // Silently fail - don't interrupt user experience
          console.debug('Visitor tracking failed:', error);
        });
      } catch (error) {
        // Silently fail
        console.debug('Visitor tracking error:', error);
      }
    };

    // Small delay to ensure page is loaded
    const timeoutId = setTimeout(trackVisit, 500);
    
    return () => clearTimeout(timeoutId);
  }, [location]);

  return null;
};

export default VisitorTracker;

